import{createContext as r}from"react";import{BaseColors as t}from"../lib/constants.js";import"../lib/tremorTwMerge.js";const o=r(t.Blue);export{o as default};
